import { render, staticRenderFns } from "./MomentFeedUser.vue?vue&type=template&id=a6b0125a&scoped=true&"
import script from "./MomentFeedUser.vue?vue&type=script&lang=js&"
export * from "./MomentFeedUser.vue?vue&type=script&lang=js&"
import style0 from "./MomentFeedUser.vue?vue&type=style&index=0&id=a6b0125a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b0125a",
  null
  
)

export default component.exports